



















































import { Vue, Component, Prop } from "vue-property-decorator";
import { MyRoutineUser } from "@/controller/my-routine-users";
import SelectionsTooltipButton from "./SelectionsTooltipButton.vue";
import TableDeleteButton from "@/components/TableDeleteButton.vue";

@Component({
  components: {
    SelectionsTooltipButton,
    TableDeleteButton
  }
})
export default class RequestTable extends Vue {
  @Prop({ type: Array, required: true })
  users!: MyRoutineUser[];

  @Prop({ type: Boolean, default: false })
  hasPrevious!: boolean;

  @Prop({ type: Boolean, default: false })
  hasNext!: boolean;

  headers = [
    {
      text: "Ngày",
      value: "updatedAt",
      width: "103px"
    },
    { text: "Tên người dùng", value: "name", width: "135px" },
    { text: "Thông tin liên lạc", value: "email", sortable: false },
    { text: "Vấn đề", value: "problem", sortable: false },
    { text: "Người tư vấn", value: "solvedBy", width: 120 },
    { text: "", value: "id", sortable: false, align: "end", width: 104 }
  ];

  onCheck(event: Event, docId: string, email: string, solvedBy: string) {
    if (!solvedBy) {
      this.$emit("check", docId, email);
    } else {
      this.$emit("check", docId, "");
    }
  }

  isDisabled(isSolved: boolean | undefined) {
    if (this.isAdmin) {
      return false;
    }
    return isSolved;
  }

  get isAdmin(): boolean {
    return this.$store.getters["user/isAdmin"];
  }

  onClickDelete(event: MouseEvent, docId: string) {
    const emitContent = event.shiftKey ? docId : "";
    this.$emit("delete", emitContent);
  }

  emitClickNext() {
    this.$emit("click-next");
  }

  emitClickPrevious() {
    this.$emit("click-previous");
  }
}
